module.exports = __webpack_public_path__ + "static/media/map-marked.5f051e17.svg";